import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Flame, Candy, Battery, Weight, ArrowDown } from 'lucide-react';
export function TruthSection() {
  const symptoms = [{
    icon: Droplets,
    text: 'Retiene agua'
  }, {
    icon: Flame,
    text: 'Te inflama'
  }, {
    icon: Candy,
    text: 'Te pide azúcar'
  }, {
    icon: Battery,
    text: 'Te quita energía'
  }, {
    icon: Weight,
    text: 'Te hace sentir pesada'
  }];
  return <section className="w-full bg-white py-20 px-4 md:px-6" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-dark mb-6" data-id="element-190">
            La verdad incómoda{' '}
            <span className="italic text-teal font-normal" data-id="element-191">
              (pero liberadora)
            </span>
          </h2>
          <p className="text-xl text-warm-gray max-w-2xl mx-auto" data-id="element-192">
            En perimenopausia/menopausia, el problema casi nunca es “comer
            mucho”. El problema es que tu cuerpo está recibiendo{' '}
            <span className="font-bold text-warm-dark" data-id="element-193">señales de amenaza</span>{' '}
            y responde como sabe:
          </p>
        </motion.div>

        {/* Symptoms Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16" data-id="element-194">
          {symptoms.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-4 bg-cream-light rounded-xl border border-cream" data-id="element-195">
              <div className="bg-white p-3 rounded-full shadow-sm mb-3 text-teal" data-id="element-196">
                <item.icon size={24} data-id="element-197" />
              </div>
              <span className="text-sm md:text-base font-medium text-warm-dark" data-id="element-198">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        {/* The Cycle */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-teal-light/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-199">
          <div className="relative z-10" data-id="element-200">
            <p className="text-xl text-warm-dark mb-8 font-medium" data-id="element-201">
              Entonces tú haces lo lógico:{' '}
              <span className="font-bold" data-id="element-202">aprietas.</span>
              <br data-id="element-203" />
              Comes menos. Te castigas. Metes más cardio.
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-204">
              <p className="text-lg font-serif italic text-teal-dark" data-id="element-205">
                Y ahí empieza el círculo:
              </p>

              <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 text-warm-gray font-medium" data-id="element-206">
                <span data-id="element-207">Más restricción</span>
                <ArrowDown className="w-4 h-4 text-teal rotate-[-90deg] md:rotate-0" data-id="element-208" />
                <span data-id="element-209">Más estrés</span>
                <ArrowDown className="w-4 h-4 text-teal rotate-[-90deg] md:rotate-0" data-id="element-210" />
                <span data-id="element-211">Peor sueño</span>
                <ArrowDown className="w-4 h-4 text-teal rotate-[-90deg] md:rotate-0" data-id="element-212" />
                <span data-id="element-213">Más inflamación</span>
                <ArrowDown className="w-4 h-4 text-teal rotate-[-90deg] md:rotate-0" data-id="element-214" />
                <span data-id="element-215">Más antojo</span>
                <ArrowDown className="w-4 h-4 text-teal rotate-[-90deg] md:rotate-0" data-id="element-216" />
                <span className="text-red-800 font-bold" data-id="element-217">Más culpa</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}